export const customTheme = {
  typography: {
    h1: {
      fontSize: '64px',
      case: 'none',
    },
  },
}
